import { render, staticRenderFns } from "./BomInfoSearch.vue?vue&type=template&id=3b200cc2&"
import script from "./BomInfoSearch.vue?vue&type=script&lang=js&"
export * from "./BomInfoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports